<div><slot :hasAccess="hasAccess"></slot></div>